@use "../../styles/mixins/component-wrapper" as wrapper;

@include wrapper.layered-component {
  .indicator {
    display: flex;
    text-align: center;
    color: var(--semantic-color-on-signal-attention-resting);
    border: var(--semantic-border-width-static) solid var(--semantic-color-border-primary-inverse-resting);
    font-family: var(--semantic-font-family-utility);
    font-size: var(--semantic-font-size-utility-indication);
    font-style: normal;
    font-weight: var(--semantic-font-weight-utility-indication);
    letter-spacing: var(--semantic-letter-spacing-utility-indication);
    border-radius: var(--semantic-border-radius-round);
    min-width: var(--indicator-count-min-width);
    height: var(--indicator-count-height);
    align-items: center;
    line-height: normal;
    width: fit-content;

    &.countless {
      min-width: unset;
      width: var(--indicator-countless-size);
      height: var(--indicator-countless-size);
    }

    &.count {
      padding: var(--indicator-count-inset-all);
    }

    /* TYPE */
    &.critical {
      background-color: var(--semantic-color-signal-attention-critical-resting);
    }

    &.warning {
      background-color: var(--semantic-color-signal-attention-warning-resting);
    }

    &.positive {
      background-color: var(--semantic-color-signal-attention-positive-resting);
    }

    &.info {
      background-color: var(--semantic-color-signal-attention-info-resting);
    }
  }
}
